module.exports = __webpack_public_path__ + "img/midi.485805d.svg";